import { isEmpty } from 'lodash'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { hideGlobalModal } from 'src/ducks/layout'
import AgendaModal from './AgendaModal'
import CPDModal from './CPDModal'
import NotificationModal from './NotificationModal'
import ProgrammeModal from './ProgrammeModal'
import RefreshModal from './RefreshModal'
import SpeakersModal from './SpeakersModal'
import LinksModal from './LinksModal'

export enum GlobalModalTypes {
  'Programme',
  'Notifications',
  'Speakers',
  'Agenda',
  'Refresh',
  'CPD',
  'Links',
}

export default function GlobalModalContainer({ currentUser }) {
  const { globalModal } = useSelector((state) => state.layout)
  const dispatch = useDispatch()

  const hideModal = () => {
    dispatch(hideGlobalModal())
  }

  switch (globalModal) {
    case GlobalModalTypes.Programme:
      return <ProgrammeModal showModal={isEmpty(globalModal)} hideModal={hideModal} />
    case GlobalModalTypes.Notifications:
      return <NotificationModal showModal={isEmpty(globalModal)} hideModal={hideModal} />
    case GlobalModalTypes.Speakers:
      return <SpeakersModal showModal={isEmpty(globalModal)} hideModal={hideModal} />
    case GlobalModalTypes.Agenda:
      return <AgendaModal showModal={isEmpty(globalModal)} hideModal={hideModal} />
    case GlobalModalTypes.Refresh:
      return <RefreshModal showModal={isEmpty(globalModal)} hideModal={hideModal} />
    case GlobalModalTypes.CPD:
      return <CPDModal showModal={isEmpty(globalModal)} hideModal={hideModal} />
    case GlobalModalTypes.Links:
      return <LinksModal showModal={isEmpty(globalModal)} hideModal={hideModal} />

    default:
      return <></>
  }
}
